module.exports = __webpack_public_path__ + "img/send.55895e3d.png";